import { useTranslation } from 'react-i18next';

export const ErrorMessage = ({ error }: { error: unknown }) => {
  const { t } = useTranslation();
  const message = error instanceof Error ? `(${error.message})` : '';

  return (
    <div>
      {t('messages.errorWhileGettingData')} {message}
    </div>
  );
};
